<template>
    <SOSlotBase :bg-white="true" :container-name="'pelunasan-invoice'" :loading="pageSetting.loading">
        <template v-slot:loading-page>
            <SOLoadingPage />
        </template>

        <template v-slot:title-bar>
            <SOTitleBar page-title="Invoice" :type="'back'" @back="back" />
        </template>

        <template v-slot:content>
            <div class="p-x-20 p-y-16" >
                <div @click.prevent.stop="toggleEnableQrisPayment()">
                    <SOInputOnOff
                        class="m-d-16"
                        :checkboxes="qrisPayment"
                        :checked="formData.auto_generate_qris_invoice > 0"
                    />
                </div>
                <p class="f-12 f-c-midgrey">
                    Menampilkan QRIS pada invoice yang dapat di-scan dan dibayar oleh konsumen. Pembayaran melalui QRIS sudah terintegrasi dengan pelunasan.
                </p>
            </div>
            <div class="separator"></div>
            <div class="p-x-20 p-y-16" >
                <div @click.prevent.stop="validateAccess('invoicePayoff.update') && requestChange()">
                    <SOInputOnOff
                        class="m-d-16"
                        :disabled="!validateAccess('invoicePayoff.update')"
                        :checkboxes="pelunasanInvoice"
                        :checked="formData.bisa_lunasi_invoice > 0"
                    />
                </div>
                <p class="f-12 f-c-midgrey">
                    Memberikan akses kepada kasir untuk melakukan pelunasan invoice konsumen.
                </p>
                <template v-if="formData.bisa_lunasi_invoice > 0">
                    <span class="f-14 f-c-midgrey">Pengaturan</span>
                    <div
                        @click="validateAccess('invoicePayoff.update') && showPengaturanModal()"
                        class="border rounded-lg p-2 d-flex justify-content-between align-items-center"
                    >
                        <div v-if="formData.bisa_lunasi_invoice === 1">
                            <div>
                                Semua Kasir Sekaligus
                            </div>
                            <span class="f-c-midgrey f-14"> Diatur untuk {{ formData.count_kasir }} kasir </span>
                        </div>
                        <div v-else-if="formData.bisa_lunasi_invoice === 2">
                            <div>
                                Kasir Tertentu
                            </div>
                        </div>
                        <div>
                            <i class="fas fa-chevron-down f-c-muted" />
                        </div>
                    </div>
                </template>
                <template v-if="formData.bisa_lunasi_invoice === 2">
                    <div class="border-top my-3" />
                    <div class="pb-2">
                        <span
                            @click="validateAccess('invoicePayoff.update') && showPengaturanModal('add')"
                            class="f-16 f-c-blue f-semi"
                        >
                            + Tambah Lainnya
                        </span>
                    </div>
                    <div
                        v-for="(item, index) in formData.listOutlet" :key="index"
                        class="dropleft border rounded-lg p-2 my-2"
                        :id="'dropdownMenu'"
                        
                    >
                        <div class="d-flex justify-content-between align-items-center" data-toggle="dropdown">
                            <div>
                                <div>
                                    {{ item.outlet.nama }}
                                </div>
                                <div class="f-12 f-c-midgrey">
                                    Diatur untuk {{ item.count_karyawan_bisa_lunasi_invoice }} kasir {{item.outlet.bisa_lunasi_invoice == 1 ? ' (Semua)' : ''}}
                                </div>
                            </div>
                            <div class="px-2">
                                <div aria-haspopup="true" aria-expanded="false">
                                    <svg width="4" height="16" viewBox="0 0 4 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.333985 2.16667C0.333985 1.24619 1.08018 0.5 2.00065 0.5C2.92113 0.5 3.66732 1.24619 3.66732 2.16667C3.66732 3.08714 2.92113 3.83333 2.00065 3.83333C1.08018 3.83333 0.333985 3.08714 0.333985 2.16667ZM0.333985 8C0.333985 7.07953 1.08018 6.33333 2.00065 6.33333C2.92113 6.33333 3.66732 7.07953 3.66732 8C3.66732 8.92047 2.92113 9.66667 2.00065 9.66667C1.08018 9.66667 0.333985 8.92047 0.333985 8ZM0.333984 13.8333C0.333984 12.9129 1.08018 12.1667 2.00065 12.1667C2.92113 12.1667 3.66732 12.9129 3.66732 13.8333C3.66732 14.7538 2.92113 15.5 2.00065 15.5C1.08018 15.5 0.333984 14.7538 0.333984 13.8333Z" fill="#6F7287"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div class="dropdown-menu" :aria-labelledby="'dropdownMenu'">
                            <button class="dropdown-item icon-2" @click="validateAccess('invoicePayoff.update') && editOutlet(item.outlet)">
                                <span class="mar-right-10">
                                    <img src="@/assets/icons/edit_2.svg" />
                                </span>
                                Ubah
                            </button>
                            <button class="dropdown-item icon-2" @click="validateAccess('invoicePayoff.update') && requestDeleteOutlet(item.outlet.idoutlet)">
                                <span class="mar-right-10">
                                    <img src="@/assets/icons/trash-red.svg" />
                                </span>
                                Hapus
                            </button>
                        </div>
                    </div>
                </template>
                <div class="f-regular f-12 m-t-16 f-c-midgrey m-d-4">
                    <template v-if="formData.bisa_lunasi_invoice > 0">
                        Kasir yang dipilih <b> bisa </b> memproses pelunasan invoice.
                    </template>
                    <template v-else>
                        <b> Kasir tidak bisa </b> memproses pelunasan invoice.
                    </template>
                </div>
            </div>
        </template>

        <template v-slot:modal>
            <ConfirmChangeModal
                :type="confirmType"
                :loading="pageSetting.loading"
                :body="confirmModalBody"
                @confirmChange="(v) => pelunasanInvoiceChange(v)"
                @confirmDeleteOutlet="(v) => deleteOutlet(v)"
                ref="confirmModal"
            />
            <AturPelunasanInvoiceModal
                :loading="pageSetting.loading"
                ref="settingInvoiceModal"
                @setLoading="(v) => pageSetting.loading = v"
            />
            <SettingOutlet
                :loading="pageSetting.loading"
                ref="settingOutletModal"
                @setLoading="(v) => pageSetting.loading = v"
            />
        </template>
    </SOSlotBase>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { moduleName } from "@/modules/pengaturan-umum/store/state";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOInputOnOff from "@/so-components/global/input/SOInputOnOff";
import SOSlotCard from "@/so-components/global/slot/SOSlotCard";
import ConfirmChangeModal from "@/modules/pengaturan-umum/views/modal/ConfirmChangeModal";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";
import AturPelunasanInvoiceModal from "@/modules/pengaturan-umum/views/modal/AturPelunasanInvoiceModal";
import SettingOutlet from "@/modules/pengaturan-umum/views/modal/UbahOutletSettingModal";
import MoreMenu from '@/so-components/global/icons/iconPacks/MoreMenu2424.vue';

export default {
    name: "AmbilTanpaPelunasan",
    components: {
        SOSlotBase,
        SOLoadingPage,
        SOTitleBar,
        SOInputOnOff,
        SOSlotCard,
        ConfirmChangeModal,
        SOInputSelect,
        AturPelunasanInvoiceModal,
        MoreMenu,
        SettingOutlet,
    },
    computed: {
        ...mapGetters("pengaturanUmumModule", {
            reminderInfo: "reminderInfo",
            reminderOption: "reminderOption",
            formData: "pelunasanInvoice",
        }),
    },
    data() {
        return {
            qrisPayment: {
                name: "enable-qris-payment",
                data: [
                    {
                        id: "rem-2",
                        value: "1",
                        title: "Aktifkan pembayaran QRIS",
                        checked: false,
                        titleBold: false,
                    },
                ],
            },
            pelunasanInvoice: {
                name: "pelunasan-invoice",
                data: [
                    {
                        id: "rem-1",
                        value: "1",
                        title: "Pelunasan Invoice oleh kasir",
                        checked: false,
                        titleBold: false,
                    },
                ],
            },
            confirmModalBody: null,
            confirmType: 'default',
            pageSetting: {
                loading: false,
                hiddenOptions: false,
            },
        };
    },
    mounted() {
        this.getInfo();
    },
    methods: {
        ...mapActions("pengaturanUmumModule", {
            getListOutlet: "getListOutlet",
            getPengaturanUmum: "getPengaturanUmum",
            enableQrisPayment: "enableQrisPayment",
        }),
        ...mapActions({
            getListKonsumen: `${moduleName}/getListKonsumen`,
        }),
        back() {
            this.$router.push({ name: "pengaturanUmum.dashboard" });
        },
        async getInfo() { 
            this.pageSetting.loading = true;
            await this.getPengaturanUmum('pelunasan_invoice')
            // this.formData = this.$store.state.pengaturanUmumModule.customerAmbilDanLunasi
            this.pageSetting.loading = false;

            setTimeout(() => {
                $(".card-body").addClass("card-body-no-footer");
            }, 100);
        },
        requestDeleteOutlet(idoutlet) {
            this.confirmModalBody = "Menghapus semua pengaturan kasir akan <b>menonaktifkan</b> pengaturan pelunasan. Yakin ingin mengubah pengaturan pelunasan invoice?" 
            this.confirmType = 'deleteOutlet'
            const request = {
                tipe_pengaturan: 0,
                idoutlet: idoutlet,
            }
            this.$refs.confirmModal.open(request)
        },
        requestChange() {
            this.confirmModalBody = "Yakin ingin mengubah pengaturan pelunasan invoice?" 
            this.confirmType = 'default'
            const request = this.formData.bisa_lunasi_invoice > 0 ? 0 : 1
            this.$refs.confirmModal.open(request)
        },
        async toggleEnableQrisPayment() {
            this.pageSetting.loading = true;
            const value = this.formData.auto_generate_qris_invoice > 0 ? 0 : 1;
            try {
                const res = await this.enableQrisPayment(value);
                if (res.success) {
                    this.$toast.success(res.msg)
                    let data = this.formData
                    data.auto_generate_qris_invoice = value
                    this.$store.commit(`${moduleName}/setPelunasanInvoice`, data)
                }
                else {
                    this.$toast.error(res.msg)
                }
            } catch (err) {
                this.$toast.error(err)
                console.log(err);
            }
            this.pageSetting.loading = false;
        },
        async deleteOutlet(requestChange) {
            this.pageSetting.loading = true;
            console.log(requestChange);
            let data = new FormData()
            data.append("idoutlet", requestChange.idoutlet)
            data.append("tipe_pengaturan", requestChange.tipe_pengaturan)
            try {
                await this.$store.dispatch("pengaturanUmumModule/updateOutletCanPaidOff", data)
                this.$toast.success('Pengaturan pelunasan traksaksi berhasil diupdate')
            } catch (error) {
                this.$toast.error(res.msg)
            }
            this.$emit("setLoading", false)
            this.$refs.confirmModal.close();
            this.pageSetting.loading = false;
        },
        async pelunasanInvoiceChange(requestChange) {
            this.pageSetting.loading = true;
            console.log(requestChange);
            let data = new FormData();
            data.append("tipe_pengaturan_kasir", requestChange);
            try {
                await this.$store.dispatch("pengaturanUmumModule/updatePelunasanInvoice", data);
                this.formData.status = requestChange
                this.$toast.success('Pengaturan pelunasan traksaksi berhasil diupdate');
            } catch (error) {
                this.$toast.error(res);
            }
            this.$refs.confirmModal.close();
            this.pageSetting.loading = false;
        },
        showPengaturanModal(mode) {
            this.$refs.settingInvoiceModal.open(this.formData.bisa_lunasi_invoice, mode);
        },
        editOutlet(outlet) {
            this.$refs.settingOutletModal.open(outlet);
        }
    },
    beforeDestroy() {
        $(".card-body").removeClass("card-body-no-footer");
    },
};
</script>

<style>
.card-body-no-footer {
    border-bottom: none !important;
    padding-bottom: 0 !important;
}
</style>
